import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";

import { energyAnalysisCacheKeys } from "../api/cacheKeys";
import { downloadCrremEnergyInputTemplate, uploadCrremEnergyInput } from "../api/callers";

export const useCrremEnergyInputUpload = (projectId: string) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const mutation = useMutation((file: File) => uploadCrremEnergyInput(projectId, file), {
    onError: () => {
      toast.error(t("general.failedSave"));
    },
    onSuccess: () => {
      toast.success(t("general.successfulFileUpload"));
      void queryClient.resetQueries(energyAnalysisCacheKeys.allScenarios(projectId));
    },
  });
  return {
    downloadTemplate: () => downloadCrremEnergyInputTemplate(String(t("general.downloadFileProblem"))),
    isUploading: mutation.isLoading,
    uploadFile: mutation.mutate,
  };
};
